import React from 'react'

import { UseFormReturn } from 'react-hook-form'

import { FormField } from '@/components/ui/form'
import { Input } from '@/components/ui/input'

import { FormFieldWrapper } from './FormFieldWrapper'

interface EmailFieldProps {
  form: UseFormReturn<any>
  name: string
  label: string
  placeholder?: string
  tooltip?: string
  desc?: string
  disabled?: boolean
  required?: boolean
  autoComplete?: React.HTMLInputAutoCompleteAttribute
  className?: string
  autoLowercase?: boolean
}

export function EmailField({
  form,
  name,
  label,
  placeholder = 'example@domain.com',
  tooltip,
  desc,
  disabled,
  required = false,
  autoComplete = 'email',
  className,
  autoLowercase = true,
}: EmailFieldProps) {
  const fieldState = form.getFieldState(name)

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormFieldWrapper label={label} tooltip={tooltip} desc={desc} required={required}>
          <Input
            {...field}
            type='email'
            placeholder={placeholder}
            disabled={disabled}
            required={required}
            autoComplete={autoComplete}
            className={className}
            aria-invalid={!!fieldState.error}
            aria-required={required}
            value={(field.value as string | undefined | null) ?? ''}
            onChange={(e) => {
              if (autoLowercase) {
                const value = e.target.value.toLowerCase()
                // Allow only valid email characters
                if (/^[a-zA-Z0-9@._+-]*$/.test(value)) {
                  field.onChange(value)
                }
              } else {
                field.onChange(e.target.value)
              }
            }}
          />
        </FormFieldWrapper>
      )}
    />
  )
}

export const MemoizedEmailField = React.memo(EmailField) as typeof EmailField
